const TYPES = {
  FORM_LINK: 'form_link',
  QRCODE: 'qrcode',
}

export { TYPES }
